import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import ShoppingItem from "./ShoppingItem";

/**
 * Wrapper drag & drop pour ShoppingItem.
 */
function SortableItem({ item, ...props }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: item.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    position: "relative",
  };

  return (
    <div ref={setNodeRef} style={style}>
      <div className="sortable-wrapper">
        <button
          className="drag-handle"
          {...attributes}
          {...listeners}
          title="Glisser pour réordonner"
        >
          &#x2261;
        </button>
        <ShoppingItem item={item} {...props} />
      </div>
    </div>
  );
}

export default SortableItem;
